import React, { useEffect } from 'react'
import { getAuthReducer } from '../../../redux/reducers/reducerSlices/AuthReducer';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { getUserSelector } from '../../../redux/reducers/reducerSlices/UserReducer';
import './Protected.css';

/**
 * Reusable component to secure protected routes.
 * Checks user authentication and permission (PageAccess) before rendering.
 * @param {*} props 
 * @returns 
 */
const Protected = (props) => {
    const { component } = props;
    const user = useSelector(getAuthReducer);
  const navigate = useNavigate();
    const location = useLocation();
    const userPermission = useSelector(getUserSelector);
  const { permissions } = userPermission || {};

    let hasAccess = false;
    if (permissions && Array.isArray(permissions) && permissions.length > 0) {
        const currentPath = location.pathname;

        const pagePermission = permissions.find(p =>
            p.PageUrl === currentPath ||
       (p.PageUrl && p.PageUrl !== '/' && currentPath.startsWith(p.PageUrl + '/'))
        );
        if (pagePermission && pagePermission.PageAccess !== undefined) {
            hasAccess = pagePermission.PageAccess === true;
  }
    }

    /**
     * useEffect to navigate user to login screen if not logged in
     */
    useEffect(() => {
    if (!user.sessionToken) {
            navigate("/");
    }
    }, [user.sessionToken])

    if (!user?.sessionToken) {
        return "";
    }

//     if (!hasAccess) {
//         return (
//       <div className="access-denied-container">
//                 <div className="access-denied-card">
//   <div className="access-denied-icon-wrapper">
//      <i className="fa-solid fa-shield-halved access-denied-icon"></i>
//            </div>
//         <h2 className="access-denied-title">Access Denied</h2>
//         <p className="access-denied-subtitle">
//        You don't have permission to view this page.
//          <br />
//           Please contact your administrator if you believe this is a mistake.
//   </p>
//           <button
//        className="access-denied-btn"
//  onClick={() => navigate("/")}
//      >
//           <i className="fa-solid fa-house"></i>
//           Go to Home
//    </button>
//                 </div>
//             </div>
//         );
//     }

    return <>{component}</>;
}

export default Protected
